<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start" >
            <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'SETTINGS' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content fullscreen="true">
    <div class="container" >
        <div class="settings-block" >[
            <div class="activity-block">
                <div class="text">{{ 'SELECT_ACTIVITY' | translate }}:</div>
                <ion-select [(ngModel)]="$activity"
                    [placeholder]="translate.instant($activity == null ?  'football' : $activity?.path)" multiple="false" >
                    <ion-select-option *ngFor="let activity of activities" [value]="activity">
                        {{ activity.path | translate }}
                    </ion-select-option>
                </ion-select>
            </div>

            <div class="perspective-block">
                <div class="text">
                    3D:
                </div>
                <ion-toggle [(ngModel)]="ls.field.threeD" (ionChange)="onThreeChange()"></ion-toggle>
            </div>
        </div>

        <div class="image-block">
            <img src="{{ '../../../../../assets/lineup/backgrounds/' + $activity?.path + '.png' }}" />
        </div>

        <!-- <ion-slides #slides class="slide" pager initialSlide="{{ activeTshirtType - 1 }}" loop (ionSlideDidChange)="slideChange($event)" slidesPerView="3">
            <ion-slide *ngFor="let type of types; let i = index">
                <div class="tshirt-block">
                    <div class="tshirt-content">
                        <svg-tshirt-container [type$]="i" [style$]="0"></svg-tshirt-container>
                    </div>
                    <div class="tshirt-text" [ngStyle]="{'font-weight': activeTshirtType == i ? 'bold': 'initial'}" (click)="clickTest(activeTshirtType, i)">
                        {{ type }}
                    </div>
                </div>
            </ion-slide>
        </ion-slides> -->
        <swiper-container
            [loop]="true"
            [slides-per-view]="3"
            [initial-slide]="activeTshirtType - 1"
            (slidechange)="slideChange($event)"
            class="slide"
            #slider
            [pagination]="pagination"
            >
            <swiper-slide *ngFor="let type of types; let i = index">
                <div class="tshirt-block">
                <div class="tshirt-content">
                    <svg-tshirt-container [type$]="i" [style$]="0"></svg-tshirt-container>
                </div>
                <div
                    class="tshirt-text"
                    [ngStyle]="{ 'font-weight': activeTshirtType == i ? 'bold' : 'initial' }"
                    (click)="clickTest(activeTshirtType, i)"
                >
                    {{ type }}
                </div>
                </div>
            </swiper-slide>
        </swiper-container>


        <ion-button expand="block" color="secondary" (click)="onWindowClose()">
            {{ 'GLOBAL_SAVE' | translate }}
        </ion-button>
    </div>
</ion-content>